export default __webpack_public_path__ + "static/back-24c6f681f3e2c6c691e689f6df5fa918.gif";